<template>
  <transition name="support-drawer">
    <div
      v-if="visible"
      class="drawer-overlay"
      @click.self="close"
    >
      <div class="drawer">

        <!-- HEADER -->

        <header class="drawer-header">

          <div
            class="grabber"
            aria-hidden="true"
          ></div>

          <div class="header-copy">
            <div class="header-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M6.5 17.5L4 19V7.5C4 5.6 5.6 4 7.5 4H16.5C18.4 4 20 5.6 20 7.5V14C20 15.9 18.4 17.5 16.5 17.5H9L6.5 19V17.5Z"
                  stroke="currentColor"
                  stroke-width="1.6"
                  stroke-linejoin="round"
                />
                <path
                  d="M8 9H16"
                  stroke="currentColor"
                  stroke-width="1.6"
                  stroke-linecap="round"
                />
                <path
                  d="M8 12.5H13.5"
                  stroke="currentColor"
                  stroke-width="1.6"
                  stroke-linecap="round"
                />
              </svg>
            </div>

            <div>
              <h3>
                Написать в поддержку
              </h3>

              <p>
                Опишите, что произошло — мы разберёмся
              </p>
            </div>
          </div>

          <button
            type="button"
            class="close-btn"
            aria-label="Закрыть"
            @click="close"
          >
            <svg
              viewBox="0 0 20 20"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M5.5 5.5L14.5 14.5"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linecap="round"
              />
              <path
                d="M14.5 5.5L5.5 14.5"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linecap="round"
              />
            </svg>
          </button>

        </header>


        <!-- BODY -->

        <section class="drawer-body">

          <!-- MESSAGE -->

          <div class="field">

            <div class="field-header">
              <label class="label">
                Сообщение
              </label>

              <span class="field-hint">
                минимум {{ MIN }} символов
              </span>
            </div>

            <div
              class="input-wrap"
              :class="{ focused }"
            >
              <textarea
                v-model="message"
                :maxlength="MAX"
                placeholder="Расскажите о проблеме или предложении..."
                @focus="focused = true"
                @blur="focused = false"
              ></textarea>

              <div
                class="counter"
                :class="{
                  limit: message.length > MAX * 0.9
                }"
              >
                {{ message.length }}/{{ MAX }}
              </div>
            </div>

          </div>


          <!-- SCREENSHOT -->

          <div class="field screenshot-field">

            <div class="field-header">
              <label class="label">
                Скриншот
              </label>

              <span class="optional">
                необязательно
              </span>
            </div>

            <div
              class="upload-area"
              :class="{
                'has-preview': preview
              }"
              @dragover.prevent
              @drop.prevent="handleDrop"
            >

              <input
                ref="fileInput"
                type="file"
                accept="image/*"
                hidden
                @change="handleFile"
              />


              <!-- EMPTY -->

              <button
                v-if="!preview"
                type="button"
                class="upload-placeholder"
                @click="openFile"
              >
                <span class="upload-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    aria-hidden="true"
                  >
                    <rect
                      x="3.5"
                      y="6.5"
                      width="17"
                      height="13"
                      rx="3"
                      stroke="currentColor"
                      stroke-width="1.5"
                    />

                    <path
                      d="M8.2 6.5L9.4 4.5H14.6L15.8 6.5"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linejoin="round"
                    />

                    <circle
                      cx="12"
                      cy="13"
                      r="3.2"
                      stroke="currentColor"
                      stroke-width="1.5"
                    />
                  </svg>
                </span>

                <span class="upload-copy">

                  <span class="upload-title">
                    Добавить скриншот
                  </span>

                  <span class="upload-description">
                    Нажмите или перетащите изображение сюда
                  </span>

                </span>
              </button>


              <!-- PREVIEW -->

              <div
                v-else
                class="preview"
              >
                <img
                  :src="preview"
                  alt="Предпросмотр скриншота"
                />

                <div class="preview-overlay">

                  <button
                    type="button"
                    class="preview-action"
                    aria-label="Заменить скриншот"
                    @click.stop="openFile"
                  >
                    <svg
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M15.5 7A6 6 0 1 0 16 12"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />

                      <path
                        d="M13.5 4.5L15.7 7L18 4.8"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>

                  <button
                    type="button"
                    class="preview-action danger"
                    aria-label="Удалить скриншот"
                    @click.stop="removeImage"
                  >
                    <svg
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M6.5 7.5V14"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />

                      <path
                        d="M10 7.5V14"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />

                      <path
                        d="M13.5 7.5V14"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />

                      <path
                        d="M4.5 5H15.5"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />

                      <path
                        d="M7.5 5V3.8H12.5V5"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linejoin="round"
                      />

                      <path
                        d="M5.8 5L6.4 16H13.6L14.2 5"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>

                </div>
              </div>

            </div>

          </div>


          <!-- SUCCESS -->

          <transition name="banner">
            <div
              v-if="success"
              class="success-banner"
            >
              <span class="success-icon">
                <svg
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M5.2 10L8.4 13.1L14.9 6.9"
                    stroke="currentColor"
                    stroke-width="1.7"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>

              <div>
                <strong>
                  Сообщение отправлено
                </strong>

                <span>
                  Спасибо! Мы получили его и скоро вернёмся с ответом.
                </span>
              </div>
            </div>
          </transition>

        </section>


        <!-- FOOTER -->

        <footer class="drawer-footer">

          <button
            type="button"
            class="cancel-btn"
            :disabled="loading || uploading"
            @click="close"
          >
            Отмена
          </button>

          <button
            type="button"
            class="send-btn"
            :disabled="disabled || loading || uploading"
            @click="send"
          >
            <span
              v-if="!loading && !uploading"
              class="send-content"
            >
              Отправить

              <svg
                viewBox="0 0 20 20"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M4 10H15.5"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />

                <path
                  d="M11.5 6L15.5 10L11.5 14"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>

            <span
              v-else
              class="dots"
            >
              <i></i>
              <i></i>
              <i></i>
            </span>
          </button>

        </footer>

      </div>
    </div>
  </transition>
</template>


<script setup>

import {
  ref,
  watch,
  computed
} from "vue";

import SupportService
  from "../../api/SupportService";


const props =
  defineProps({

    visible: {
      type: Boolean,
      default: false
    }

  });


const emit =
  defineEmits([
    "close",
    "sent",
    "snackbar"
  ]);


const MAX = 600;
const MIN = 8;


const file =
  ref(null);

const preview =
  ref(null);

const uploading =
  ref(false);

const fileInput =
  ref(null);

const message =
  ref("");

const loading =
  ref(false);

const success =
  ref(false);

const focused =
  ref(false);


const disabled =
  computed(() =>
    message.value.trim().length < MIN
  );


function clearPreview() {

  if (
    preview.value &&
    preview.value.startsWith("blob:")
  ) {
    URL.revokeObjectURL(
      preview.value
    );
  }

  preview.value = null;
}


function reset() {

  clearPreview();

  file.value = null;

  message.value = "";

  loading.value = false;

  uploading.value = false;

  success.value = false;

  focused.value = false;


  if (fileInput.value) {
    fileInput.value.value = "";
  }

}


function close() {

  reset();

  emit("close");

}


async function send() {

  if (
    disabled.value ||
    loading.value ||
    uploading.value
  ) {
    return;
  }


  loading.value = true;


  try {

    let screenshotUrl =
      null;


    if (file.value) {

      uploading.value =
        true;


      try {

        screenshotUrl =
          await SupportService
            .uploadBugScreenshot(
              file.value
            );

      } finally {

        uploading.value =
          false;

      }

    }


    await SupportService
      .sendBugReport({

        message:
          message.value.trim(),

        screenshot_url:
          screenshotUrl,

        page:
          window.location.href,

        browser:
          navigator.userAgent,

        platform:
          "web"

      });


    success.value =
      true;


    emit(
      "sent"
    );


    emit(
      "snackbar",
      {
        message:
          "Сообщение отправлено",
        type:
          "success"
      }
    );


    setTimeout(
      close,
      1100
    );

  } catch (error) {

    console.error(
      "Support request error:",
      error
    );


    emit(
      "snackbar",
      {
        message:
          "Не удалось отправить сообщение",
        type:
          "error"
      }
    );

  } finally {

    loading.value =
      false;

  }

}


function openFile() {

  fileInput.value?.click();

}


function setFile(f) {

  if (
    !f ||
    !f.type?.startsWith("image/")
  ) {
    return;
  }


  clearPreview();


  file.value =
    f;


  preview.value =
    URL.createObjectURL(
      f
    );

}


function handleFile(event) {

  const f =
    event.target.files?.[0];


  setFile(f);

}


function handleDrop(event) {

  const f =
    event.dataTransfer.files?.[0];


  setFile(f);

}


function removeImage() {

  clearPreview();

  file.value =
    null;


  if (fileInput.value) {
    fileInput.value.value = "";
  }

}


watch(
  () => props.visible,
  value => {

    if (!value) {
      reset();
    }

  }
);

</script>


<style scoped>

/* ============================================================
   OVERLAY
============================================================ */

.drawer-overlay {
  position: fixed;

  inset: 0;

  z-index: 2000;

  display: flex;
  align-items: flex-end;
  justify-content: center;

  background:
    rgba(10, 14, 20, 0.42);

  backdrop-filter:
    blur(7px);

  -webkit-backdrop-filter:
    blur(7px);
}


/* ============================================================
   DRAWER
============================================================ */

.drawer {
  width: 100%;
  max-width: 720px;

  overflow: hidden;

  color:
    #292e35;

  background:
    rgba(255, 255, 255, 0.98);

  border:
    1px solid
    rgba(25, 40, 60, 0.07);

  border-bottom: none;

  border-radius:
    24px
    24px
    0
    0;

  box-shadow:
    0
    -18px
    60px
    rgba(0, 0, 0, 0.18);
}


/* ============================================================
   HEADER
============================================================ */

.drawer-header {
  position: relative;

  padding:
    13px
    22px
    17px;

  border-bottom:
    1px solid
    rgba(35, 50, 70, 0.065);
}


.grabber {
  width: 38px;
  height: 4px;

  margin:
    0
    auto
    16px;

  background:
    rgba(50, 60, 75, 0.14);

  border-radius:
    999px;
}


.header-copy {
  display: flex;
  align-items: center;

  gap: 12px;

  padding-right:
    42px;
}


.header-icon {
  width: 38px;
  height: 38px;

  flex:
    0
    0
    38px;

  display: flex;
  align-items: center;
  justify-content: center;

  color:
    #4779b8;

  background:
    rgba(60, 115, 190, 0.08);

  border:
    1px solid
    rgba(60, 115, 190, 0.08);

  border-radius:
    11px;
}


.header-icon svg {
  width: 18px;
  height: 18px;
}


.drawer-header h3 {
  margin: 0;

  color:
    #2b3037;

  font-family:
    "Eastman-Bold",
    sans-serif;

  font-size:
    15px;

  line-height:
    1.2;

  letter-spacing:
    -0.25px;
}


.drawer-header p {
  margin:
    4px
    0
    0;

  color:
    #8b9199;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    10px;

  line-height:
    1.35;
}


/* ============================================================
   CLOSE
============================================================ */

.close-btn {
  position: absolute;

  top: 37px;
  right: 18px;

  width: 31px;
  height: 31px;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0;

  color:
    #7a828c;

  background:
    #f4f6f8;

  border:
    1px solid
    rgba(30, 45, 65, 0.055);

  border-radius:
    9px;

  cursor: pointer;

  transition:
    color .18s ease,
    background-color .18s ease,
    transform .18s ease;
}


.close-btn svg {
  width: 15px;
  height: 15px;
}


.close-btn:hover {
  color:
    #424950;

  background:
    #eceff3;

  transform:
    scale(1.04);
}


/* ============================================================
   BODY
============================================================ */

.drawer-body {
  padding:
    20px
    22px
    10px;
}


.field + .field {
  margin-top:
    20px;
}


.field-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: 12px;

  margin-bottom:
    8px;
}


.label {
  color:
    #555d67;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    11px;

  line-height:
    1.2;
}


.field-hint,
.optional {
  color:
    #a0a6ae;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    9px;
}


/* ============================================================
   TEXTAREA
============================================================ */

.input-wrap {
  position: relative;

  overflow: hidden;

  background:
    #f5f7f9;

  border:
    1px solid
    rgba(40, 60, 85, 0.075);

  border-radius:
    15px;

  transition:
    background-color .2s ease,
    border-color .2s ease,
    box-shadow .2s ease;
}


.input-wrap.focused {
  background:
    #ffffff;

  border-color:
    rgba(55, 127, 228, 0.45);

  box-shadow:
    0
    0
    0
    4px
    rgba(55, 127, 228, 0.065);
}


textarea {
  width: 100%;
  min-height: 130px;

  box-sizing: border-box;

  display: block;

  resize: vertical;

  padding:
    14px
    15px
    32px;

  color:
    #373d44;

  background:
    transparent;

  border:
    none;

  outline:
    none;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    13px;

  line-height:
    1.5;
}


textarea::placeholder {
  color:
    #a7adb5;
}


.counter {
  position: absolute;

  right: 13px;
  bottom: 10px;

  color:
    #a1a7ae;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    9px;

  transition:
    color .18s ease;
}


.counter.limit {
  color:
    #bd7d63;
}


/* ============================================================
   UPLOAD
============================================================ */

.upload-area {
  position: relative;

  overflow: hidden;

  min-height: 90px;

  display: flex;

  background:
    #f7f8fa;

  border:
    1px dashed
    rgba(65, 85, 110, 0.20);

  border-radius:
    15px;

  transition:
    background-color .2s ease,
    border-color .2s ease;
}


.upload-area:not(.has-preview):hover {
  background:
    #f2f6fb;

  border-color:
    rgba(55, 127, 228, 0.35);
}


.upload-placeholder {
  width: 100%;
  min-height: 90px;

  display: flex;
  align-items: center;

  gap: 12px;

  box-sizing: border-box;

  padding:
    15px;

  text-align:
    left;

  color:
    inherit;

  background:
    transparent;

  border:
    none;

  cursor:
    pointer;
}


.upload-icon {
  width: 40px;
  height: 40px;

  flex:
    0
    0
    40px;

  display: flex;
  align-items: center;
  justify-content: center;

  color:
    #748ba8;

  background:
    #ffffff;

  border:
    1px solid
    rgba(40, 65, 95, 0.06);

  border-radius:
    11px;

  box-shadow:
    0
    5px
    14px
    rgba(15, 23, 42, 0.035);
}


.upload-icon svg {
  width: 19px;
  height: 19px;
}


.upload-copy {
  display: flex;
  flex-direction: column;

  min-width: 0;
}


.upload-title {
  color:
    #4a525d;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    11px;
}


.upload-description {
  margin-top:
    4px;

  color:
    #969da6;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    9px;

  line-height:
    1.35;
}


/* ============================================================
   PREVIEW
============================================================ */

.preview {
  position: relative;

  width: 100%;
}


.preview img {
  width: 100%;
  height: 190px;

  display: block;

  object-fit:
    cover;
}


.preview-overlay {
  position: absolute;

  top: 10px;
  right: 10px;

  display: flex;

  gap: 6px;
}


.preview-action {
  width: 30px;
  height: 30px;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0;

  color:
    #ffffff;

  background:
    rgba(20, 25, 32, 0.65);

  border:
    1px solid
    rgba(255, 255, 255, 0.10);

  border-radius:
    9px;

  backdrop-filter:
    blur(10px);

  cursor:
    pointer;

  transition:
    background-color .18s ease,
    transform .18s ease;
}


.preview-action svg {
  width: 15px;
  height: 15px;
}


.preview-action:hover {
  background:
    rgba(20, 25, 32, 0.82);

  transform:
    scale(1.04);
}


.preview-action.danger:hover {
  background:
    rgba(150, 55, 55, 0.82);
}


/* ============================================================
   SUCCESS
============================================================ */

.success-banner {
  margin-top:
    16px;

  display: flex;
  align-items: flex-start;

  gap: 10px;

  padding:
    12px;

  color:
    #4f806b;

  background:
    rgba(70, 155, 115, 0.075);

  border:
    1px solid
    rgba(70, 155, 115, 0.11);

  border-radius:
    13px;
}


.success-icon {
  width: 25px;
  height: 25px;

  flex:
    0
    0
    25px;

  display: flex;
  align-items: center;
  justify-content: center;

  background:
    rgba(70, 155, 115, 0.10);

  border-radius:
    8px;
}


.success-icon svg {
  width: 15px;
  height: 15px;
}


.success-banner strong {
  display: block;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    10px;
}


.success-banner span {
  display: block;

  margin-top:
    3px;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    9px;

  line-height:
    1.4;
}


/* ============================================================
   FOOTER
============================================================ */

.drawer-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  gap: 9px;

  padding:
    14px
    22px
    20px;

  border-top:
    1px solid
    rgba(35, 50, 70, 0.06);
}


.cancel-btn,
.send-btn {
  height: 40px;

  box-sizing: border-box;

  padding:
    0
    17px;

  border-radius:
    11px;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    11px;

  cursor:
    pointer;

  transition:
    background-color .18s ease,
    color .18s ease,
    border-color .18s ease,
    box-shadow .18s ease,
    transform .18s ease,
    opacity .18s ease;
}


.cancel-btn {
  color:
    #737b85;

  background:
    transparent;

  border:
    1px solid
    rgba(40, 55, 75, 0.09);
}


.cancel-btn:hover {
  color:
    #474f59;

  background:
    #f3f5f7;
}


.send-btn {
  min-width:
    132px;

  color:
    #ffffff;

  background:
    linear-gradient(
      135deg,
      #3d86e5,
      #326fbf
    );

  border:
    1px solid
    rgba(45, 105, 190, 0.15);

  box-shadow:
    0
    8px
    18px
    rgba(45, 105, 190, 0.16);
}


.send-btn:not(:disabled):hover {
  transform:
    translateY(-1px);

  box-shadow:
    0
    11px
    23px
    rgba(45, 105, 190, 0.22);
}


.send-btn:disabled,
.cancel-btn:disabled {
  opacity:
    .45;

  cursor:
    default;

  pointer-events:
    none;
}


.send-content {
  display: flex;
  align-items: center;
  justify-content: center;

  gap: 7px;
}


.send-content svg {
  width: 14px;
  height: 14px;
}


/* ============================================================
   LOADING
============================================================ */

.dots {
  display: inline-flex;
  align-items: center;

  gap: 4px;
}


.dots i {
  width: 5px;
  height: 5px;

  display: block;

  background:
    currentColor;

  border-radius:
    50%;

  animation:
    bounce
    .9s
    infinite
    ease-in-out;
}


.dots i:nth-child(2) {
  animation-delay:
    .1s;
}


.dots i:nth-child(3) {
  animation-delay:
    .2s;
}


@keyframes bounce {

  0%,
  80%,
  100% {
    transform:
      translateY(0);

    opacity:
      .55;
  }

  40% {
    transform:
      translateY(-3px);

    opacity:
      1;
  }

}


/* ============================================================
   DRAWER TRANSITION
============================================================ */

.support-drawer-enter-active,
.support-drawer-leave-active {
  transition:
    opacity
    .22s
    ease;
}


.support-drawer-enter-from,
.support-drawer-leave-to {
  opacity:
    0;
}


.support-drawer-enter-from
.drawer,
.support-drawer-leave-to
.drawer {
  transform:
    translateY(100%);

  opacity:
    0;
}


.support-drawer-enter-active
.drawer,
.support-drawer-leave-active
.drawer {
  transition:
    transform
    .28s
    cubic-bezier(.2, .8, .3, 1),
    opacity
    .22s
    ease;
}


/* ============================================================
   SUCCESS TRANSITION
============================================================ */

.banner-enter-active,
.banner-leave-active {
  transition:
    opacity .18s ease,
    transform .18s ease;
}


.banner-enter-from,
.banner-leave-to {
  opacity:
    0;

  transform:
    translateY(5px);
}


/* ============================================================
   DARK
============================================================ */

html[data-theme="dark"]
.drawer-overlay {
  background:
    rgba(0, 0, 0, 0.55);
}


html[data-theme="dark"]
.drawer {
  color:
    #eef0f3;

  background:
    linear-gradient(
      145deg,
      #22242a,
      #1d1f24
    );

  border-color:
    rgba(255, 255, 255, 0.07);

  box-shadow:
    0
    -20px
    70px
    rgba(0, 0, 0, 0.42);
}


html[data-theme="dark"]
.drawer-header,
html[data-theme="dark"]
.drawer-footer {
  border-color:
    rgba(255, 255, 255, 0.055);
}


html[data-theme="dark"]
.grabber {
  background:
    rgba(255, 255, 255, 0.15);
}


html[data-theme="dark"]
.header-icon {
  color:
    #91b6ee;

  background:
    rgba(90, 135, 195, 0.09);

  border-color:
    rgba(115, 155, 210, 0.08);
}


html[data-theme="dark"]
.drawer-header h3 {
  color:
    #f0f1f3;
}


html[data-theme="dark"]
.drawer-header p {
  color:
    #858a93;
}


html[data-theme="dark"]
.close-btn {
  color:
    #a4aab2;

  background:
    rgba(255, 255, 255, 0.04);

  border-color:
    rgba(255, 255, 255, 0.055);
}


html[data-theme="dark"]
.close-btn:hover {
  color:
    #e2e5e9;

  background:
    rgba(255, 255, 255, 0.065);
}


html[data-theme="dark"]
.label {
  color:
    #c7cbd1;
}


html[data-theme="dark"]
.field-hint,
html[data-theme="dark"]
.optional {
  color:
    #6f747c;
}


html[data-theme="dark"]
.input-wrap {
  background:
    rgba(255, 255, 255, 0.025);

  border-color:
    rgba(255, 255, 255, 0.065);
}


html[data-theme="dark"]
.input-wrap.focused {
  background:
    rgba(255, 255, 255, 0.035);

  border-color:
    rgba(91, 158, 255, 0.36);

  box-shadow:
    0
    0
    0
    4px
    rgba(91, 158, 255, 0.055);
}


html[data-theme="dark"]
textarea {
  color:
    #dde1e6;
}


html[data-theme="dark"]
textarea::placeholder {
  color:
    #626871;
}


html[data-theme="dark"]
.counter {
  color:
    #666c75;
}


html[data-theme="dark"]
.upload-area {
  background:
    rgba(255, 255, 255, 0.022);

  border-color:
    rgba(255, 255, 255, 0.09);
}


html[data-theme="dark"]
.upload-area:not(.has-preview):hover {
  background:
    rgba(90, 135, 195, 0.045);

  border-color:
    rgba(110, 155, 220, 0.18);
}


html[data-theme="dark"]
.upload-icon {
  color:
    #91a7c3;

  background:
    rgba(255, 255, 255, 0.035);

  border-color:
    rgba(255, 255, 255, 0.05);

  box-shadow:
    none;
}


html[data-theme="dark"]
.upload-title {
  color:
    #cfd3d9;
}


html[data-theme="dark"]
.upload-description {
  color:
    #727881;
}


html[data-theme="dark"]
.cancel-btn {
  color:
    #969ca5;

  border-color:
    rgba(255, 255, 255, 0.065);
}


html[data-theme="dark"]
.cancel-btn:hover {
  color:
    #d3d6db;

  background:
    rgba(255, 255, 255, 0.04);
}


html[data-theme="dark"]
.send-btn {
  background:
    linear-gradient(
      135deg,
      #3b6ea8,
      #304f78
    );

  border-color:
    rgba(255, 255, 255, 0.065);

  box-shadow:
    0
    9px
    22px
    rgba(0, 0, 0, 0.20);
}


html[data-theme="dark"]
.success-banner {
  color:
    #91b9a6;

  background:
    rgba(75, 150, 110, 0.07);

  border-color:
    rgba(90, 170, 130, 0.10);
}


/* ============================================================
   MOBILE
============================================================ */

@media (max-width: 600px) {

  .drawer {
    max-height:
      92dvh;

    overflow-y:
      auto;

    border-radius:
      22px
      22px
      0
      0;
  }


  .drawer-header {
    padding:
      12px
      16px
      15px;
  }


  .close-btn {
    right:
      14px;
  }


  .drawer-body {
    padding:
      18px
      16px
      8px;
  }


  .drawer-footer {
    padding:
      13px
      16px
      calc(
        16px +
        env(safe-area-inset-bottom)
      );
  }


  .header-icon {
    display:
      none;
  }


  textarea {
    min-height:
      120px;
  }


  .cancel-btn {
    display:
      none;
  }


  .send-btn {
    width:
      100%;
  }

}


/* ============================================================
   REDUCED MOTION
============================================================ */

@media (prefers-reduced-motion: reduce) {

  .support-drawer-enter-active,
  .support-drawer-leave-active,
  .support-drawer-enter-active .drawer,
  .support-drawer-leave-active .drawer,
  .banner-enter-active,
  .banner-leave-active,
  .send-btn,
  .close-btn,
  .upload-area,
  .preview-action,
  .input-wrap {
    transition:
      none;
  }


  .dots i {
    animation:
      none;
  }

}

</style>